import { COLORS, TYPOGRAPHY } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

const styles = createStyleSheet({
  container: {
    paddingLeft: 32,
    paddingRight: 32,
    paddingBottom: 128,
  },
  contentContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    paddingTop: 32,
    gap: 16,
  },
  selection: {
    height: 128,
    width: 597,
    padding: 32,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: COLORS.WHITE.DEFAULT,
    backgroundColor: COLORS.TEXT.ACCENTUATED,
  },
  selectionText: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 32,
    gap: 16,
  },
  selectButton: {
    height: 32,
  },
  selectedItems: {
    ...TYPOGRAPHY.H2,
    color: COLORS.WHITE.DEFAULT,
  },
  empty: {
    paddingTop: 48,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  emptyTitle: {
    ...TYPOGRAPHY.H2_BOLD,
    marginBottom: 8,
    textAlign: 'center',
  },
  emptySubTitle: {
    ...TYPOGRAPHY.BODY4,
    color: COLORS.TEXT.SECONDARY_DEFAULT,
    textAlign: 'center',
  },
  newContentButton: {
    marginTop: 24,
  },
  loadMore: {
    display: 'flex',
    justifyContent: 'center',
    padding: 40,
    position: 'relative',
  },
  filter: {
    width: '100%',
    display: 'block',
  },
  filterContainer: {
    minWidth: 0,
    width: '100%',
  },
});

export default styles;
